import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import asscentsLogo from "../../assets/asscentsLogo.png";
import back from "../../assets/back.svg";
import { privacyPolicy } from "../../redux/actions/commonActions";
import "./static-pages.css";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [privacyData, setPrivacyData] = useState("");

  useEffect(() => {
    dispatch(privacyPolicy(onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setPrivacyData(data.data.data);
    console.log(data.data.data);
  };

  const onError = (err) => {
    console.log(err);
  };
  return (
    <div className="static-body-container">
      <div className="w-100 static-top-nav">
        <div className="">
          <img src={asscentsLogo} alt="Asscents Logo" className="svgAsscents" />
        </div>
      </div>
      <div
        className="d-flex p-2 ms-3 m-1 mb-2 cursor_pointer"
        onClick={() => navigate(-1)}
      >
        <img src={back} alt="back_btn" />
        <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
          BACK
        </span>
      </div>
      <div className="d-flex justify-content-center align-items-center m-2 fn_Nunito">
        <div className="static-main-container text-center mx-2 p-4">
          <p className="fs_38 m-lg-2">Privacy policy</p>
          <p
            className="color_747f9e w-100 static-text"
            dangerouslySetInnerHTML={{ __html: privacyData?.privacy }}
          ></p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
